import { DateTime } from 'luxon';
import toLuxonObject from './toLuxonObject';

export default function toISODateString(date, currentFormat) {
  const dateObj = (date instanceof DateTime) ? date : toLuxonObject(date, currentFormat);
  if (!dateObj) return null;

  // Maintain performance by using string concatenation instead of template literals
  // eslint-disable-next-line prefer-template
  return dateObj.year + '-' + String(dateObj.month).padStart(2, '0') + '-' + String(dateObj.day).padStart(2, '0');
}
